import styled from '@emotion/styled';

export const Container = styled.form`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
`;

export const CardContent = styled.div`
    display: flex;
    flex-direction: column;

    > h2 {
        margin-bottom: ${({ theme }) => theme.base.spacing[4]};
    }
`;

export const Line = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.base.spacing[1]};
    padding-bottom: ${({ theme }) => theme.base.spacing[4]};

    > div:first-of-type {
        flex: 2;
    }

    > div:last-child {
        flex: 1;
    }

    > div > div {
        height: 50px;
    }
`;

export const TermsAndConditions = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.base.spacing[3]};
    border-top: ${({ theme }) => `0.5px solid ${theme.base.color.separator}`};
    padding-top: ${({ theme }) => theme.base.spacing[4]};

    & a {
        text-decoration: underline ${({ theme }) => theme.feature.text.color};
    }
`;

export const CheckboxContainer = styled.div`
    display: flex;
`;

export const Privacy = styled.div`
    background-color: ${({ theme }) => theme.base.color.grey100};
    margin-bottom: ${({ theme }) => theme.base.spacing[4]};
    margin-left: -${({ theme }) => theme.base.spacing[4]};
    margin-right: -${({ theme }) => theme.base.spacing[4]};
    padding: ${({ theme }) => theme.base.spacing[4]};
`;

export const IconsContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.base.spacing[4]};
    padding-top: ${({ theme }) => theme.base.spacing[3]};
    align-items: center;
`;

export const BottomBar = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: ${({ theme }) => theme.base.spacing[4]};
`;

export const ErrorContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.base.spacing[4]};
`;
